<template>
    <div class="logo py-2">
        <a v-if="url" :href="url">
            <img class="d-inline d-sm-none" :title="title" :alt="title" :src="srcIcon" />
            <img class="d-none d-sm-inline" :title="title" :alt="title" :src="srcLogo" />
        </a>
        <div v-else>
            <img class="d-inline d-sm-none" :title="title" :alt="title" :src="srcIcon" />
            <img class="d-none d-sm-inline" :title="title" :alt="title" :src="srcLogo" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageHeaderLogo",

        props: {
            url: {type: String},
            title: {type: String},
            srcLogo: {type: String},
            srcIcon: {type: String},
        },
    }
</script>

<style scoped>
    .logo img{
        max-height: 3rem;
        max-width: 100%;
        height: auto;
        width: auto\9; /* ie8 */
    }
</style>
